/*
 * @Description: description
 * @Author: chenguobiao
 * @Date: 2021-09-13 09:29:47
 * @LastEditTime: 2021-10-14 17:43:56
 * @LastEditors: chenguobiao
 */
import { USER_TOKEN } from '@/config/const'
export default class Auth {
  static getToken() {
    return localStorage.getItem(USER_TOKEN)
  }
  static setToken(token) {
    return localStorage.setItem(USER_TOKEN, token)
  }
  static getUsername() {
    return localStorage.getItem('username')
  }

  static setUsername(username) {
    return localStorage.setItem('username', username)
  }
}
